<template>
  <v-container>
    <v-row justify="space-between">
      <!--Scroll List-->
      <v-col
        cols="12"
        lg="2"
        md="2"
        class="hidden-sm-and-down"
        style="margin-top: 80px"
      >
        <ScrollList ref="scrollList" :offset="-5" :items="scrollListItems" />
      </v-col>

      <!--Page Content-->
      <v-col cols="12" lg="10" md="10" sm="12" xs="12">
        <v-row justify="center">
          <v-col cols="12" lg="10" md="10" >
            <div ref="aboutconference">
              <h2 class="ml-0">
                {{ $t("ABOUT.main_title") }}
              </h2>
              <div class="description">
                <p v-html="$t('CALLFORPAPERS.presentation_about_text')"></p>
              </div>
            </div>

            <v-row class="pt-6 ma-0" justify="space-between" ref="dates">
              <v-col cols="12" lg="6" md="6" sm="6" xs="12">
                <h2 class="ml-0">{{ $t("ABOUT.dates_title") }}</h2>
                <dates
                  :deadlines="trackContent != undefined ? deadlines : []"
                />
              </v-col>
              <v-col cols="12" lg="6" md="6" sm="6" xs="12">
                <v-row class="ma-0" justify="end">
                  <v-col
                    cols="12"
                    lg="10"
                    md="10"
                    sm="10"
                    xs="10"
                    class="hidden-sm-and-down"
                  >
                    <v-img
                      width="500"
                      src="@/assets/others/calendar-booking.svg"
                      alt="Calendar booking Illustration - image"
                    >
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height ma-0"
                          align="center"
                          justify="center"
                        >
                          <v-progress-circular
                            indeterminate
                            color="white"
                            size="60"
                          ></v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

            <div ref="tracks">
              <h2 class="ml-0">
                {{ $t("CALLFORPAPERS.tracks_title") }}
              </h2>
              <!--full-papers-->
              <h3 class="pt-4">
                <p
                  v-html="$t('CALLFORPAPERS.tracks_info.full_papers.title')"
                ></p>
              </h3>
              <div class="description">
                <span
                  v-html="
                    $t('CALLFORPAPERS.tracks_info.full_papers.description')
                  "
                ></span>
                <a
                  id="conference-to-maintrack"
                  :href="$t('CALLFORPAPERS.tracks_info.full_papers.link_route')"
                  >{{
                    $t("CALLFORPAPERS.tracks_info.full_papers.link_title")
                  }}</a
                >
              </div>

              <!--in-progress-->
              <h3 class="pt-6">
                <p v-html="$t('CALLFORPAPERS.tracks_info.student.title')"></p>
              </h3>
              <div class="description">
                <span
                  v-html="$t('CALLFORPAPERS.tracks_info.student.description')"
                ></span>
                <a
                  id="conference-to-student"
                  :href="$t('CALLFORPAPERS.tracks_info.student.link_route')"
                  >{{ $t("CALLFORPAPERS.tracks_info.student.link_title") }}</a
                >
              </div>

              <!--hci-and-games-->
              <h3 class="pt-6">
                <p
                  v-html="$t('CALLFORPAPERS.tracks_info.hci_and_games.title')"
                ></p>
              </h3>
              <div class="description">
                <span
                  v-html="
                    $t('CALLFORPAPERS.tracks_info.hci_and_games.description')
                  "
                ></span>
                <a
                  id="conference-to-games"
                  :href="
                    $t('CALLFORPAPERS.tracks_info.hci_and_games.link_route')
                  "
                  >{{
                    $t("CALLFORPAPERS.tracks_info.hci_and_games.link_title")
                  }}</a
                >
              </div>

              <!--mini-courses-->
              <h3 class="pt-6">
                <p
                  v-html="$t('CALLFORPAPERS.tracks_info.mini_courses.title')"
                ></p>
              </h3>
              <div class="description">
                <span
                  v-html="
                    $t('CALLFORPAPERS.tracks_info.mini_courses.description')
                  "
                ></span>
                <a
                  id="conference-to-minicourses"
                  :href="
                    $t('CALLFORPAPERS.tracks_info.mini_courses.link_route')
                  "
                  >{{
                    $t("CALLFORPAPERS.tracks_info.mini_courses.link_title")
                  }}</a
                >
              </div>

              <!--3wosi2-->
              <h3 class="pt-6">
                <p v-html="$t('CALLFORPAPERS.tracks_info.3wosi2.title')"></p>
              </h3>
              <div class="description">
                <span
                  v-html="$t('CALLFORPAPERS.tracks_info.3wosi2.description')"
                ></span>
                <a
                  id="conference-to-3wosi2"
                  :href="$t('CALLFORPAPERS.tracks_info.3wosi2.link_route')"
                  >{{ $t("CALLFORPAPERS.tracks_info.3wosi2.link_title") }}</a
                >
              </div>
            </div>

            <partners ref="partners" />

            <v-row align="center" class="pl-2" ref="coordination">
              <v-col cols="12" lg="6" md="6" sm="12" xs="12" class="pa-0">
                <h2>
                  {{ $t("CALLFORPAPERS.general_coordination_title") }}
                </h2>
                <!--titulo-->
                <div>
                  <speakerGroup v-bind:data="coordinationGeneral" />
                </div>
              </v-col>
              <v-col cols="6" class="hidden-sm-and-down">
                <v-img
                  max-height="320"
                  contain
                  src="@/assets/tracks/chairsImage.svg"
                  alt="Chairs Illustration - image"
                ></v-img>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Partners from "@/components/atoms/Partners.vue";
import SpeakerGroup from "@/components/molecules/SpeakerGroup.vue";
import Dates from "@/components/molecules/Dates.vue";
import ScrollList from "@/components/atoms/tracks/[TRACK]ScrollList.vue";

export default {
  components: {
    Partners,
    SpeakerGroup,
    Dates,
    ScrollList,
  },
  metaInfo() {
    return {
      // Title to tab on browser
      title: `${this.$i18n.t("METAINFO.conference.tab_title")}`,
      meta: [
        //Basic metas
        {
          name: "title",
          content: `${this.$i18n.t("METAINFO.conference.title")}`,
        },
        {
          name: "description",
          content: `${this.$i18n.t("METAINFO.conference.description")}`,
        },
        {
          name: "keywords",
          content: `${this.$i18n.t("METAINFO.conference.keywords")}`,
        },

        // OpenGraph data
        {
          property: "og:title",
          content: `${this.$i18n.t("METAINFO.conference.title")}`,
        },
        { property: "og:url", content: "https://hci2021.web.app/conference" },
        {
          property: "og:description",
          content: `${this.$i18n.t("METAINFO.conference.description")}`,
        },

        // Twitter card
        {
          name: "twitter:title",
          content: `${this.$i18n.t("METAINFO.conference.title")}`,
        },
        { name: "twitter:card", content: "summary" },
        { name: "twitter:site", content: "https://hci2021.web.app/conference" },
        {
          name: "twitter:description",
          content: `${this.$i18n.t("METAINFO.conference.description")}`,
        },

        //Google Schema
        {
          itemprop: "name",
          content: `${this.$i18n.t("METAINFO.conference.title")}`,
        },
        {
          itemprop: "description",
          content: `${this.$i18n.t("METAINFO.conference.description")}`,
        },
      ],
      link: [{ rel: "canonical", href: "https://hci2021.web.app/conference" }],
    };
  },
  data() {
    return {
      coordinationGeneral: [
        {
          image: require("@/assets/committee/valeria.jpg"),
          title: "Valéria Farinazzo Martins",
          subtitle: "Universidade Presbiteriana Mackenzie, Brasil",
          email: "valfarinazzo@gmail.com",
        },
        {
          image: require("@/assets/committee/cesar.jpg"),
          title: "Presidente de la Conferencia - Cesar Collazos",
          subtitle: "U. Cauca-Colombia",
          email: "ccollazo@unicauca.edu.co",
        },
      ],
      pubDesc:
        "All works will be evaluated by double blind review by at least two members of the technical committee. The selected works will be presented at the event and will be included in the memories of the VI IBERO-AMERICAN DAYS OF HUMAN-COMPUTER INTERACTION. At least one author of the article must pay the registration as a speaker, however, if the work is not presented at the event, it will be removed from the reports.Some of the best works will be invited to send extended versions to be considered for publication in the special edition: Infotainment Systems and Intelligent Vehicles, in Sustainability Magazine",
    };
  },
  computed: {
    currentTrack() {
      return this.$store.getters.currentTrack;
    },
    trackContent() {
      return this.currentTrack?.content?.[`${this.$i18n.locale}`];
    },
    deadlines() {
      return this.trackContent.deadlines;
    },
    scrollListItems() {
      let items = [
        { title: this.$t("ABOUT.main_title"), ref: "aboutconference" },
        { title: this.$t("ABOUT.dates_title"), ref: "dates" },
        { title: this.$t("CALLFORPAPERS.tracks_title"), ref: "tracks" },
        { title: this.$t("ABOUT.partners_title"), ref: "partners" },
        {
          title: this.$t("CALLFORPAPERS.general_coordination_title"),
          ref: "coordination",
        },
      ];
      return items;
    },
  },
  async created() {
    this.$store.dispatch("getTrackByRouteName", "/fullpapers");
  },
};
</script>

<style scoped>
.subject-title {
  font-size: 120%;
  font-weight: 700;
  color: #4f4f4f;
  font-family: "Open Sans", sans-serif;
  padding-bottom: 10px;
}
</style>
